import {Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import {MatCheckboxChange, MatSnackBar, MatSnackBarConfig} from '@angular/material';
import {AttachmentsBlock, AttachmentsBlocksList, GenericAttachedFile} from '@shared/components/view-files/models/attachments-interface';
import {Utilities as U} from '@shared/utilities/utilities.model';
import {UploadFileService} from '@shared/service/upload-file.service';
import {TranslateContext, TranslatePipe} from '@shared/pipes/translate.pipe';
import {FormItemsModel} from 'app/authority/authority-shared/models/form-items.model';
import {WorkingModel} from 'app/authority/authority-shared/models/working.model';
import {DossierModel} from 'app/authority/authority-shared/models/dossier.model';
import {WorkingTypes} from 'app/authority/authority-shared/models/enums.model';
import {PermissionService} from '@shared/service/permission.service';
import { BookingsProfileKey } from 'app/bookings/models/enums.models';
import { PROFILES_CLAIMS_AUTHORITY_KEY, PROFILES_CLAIMS_DEKRA_READONLY_KEY, PROFILE_CLAIMS_READONLY_LIST } from 'app/permissions-variables';
import { BookingFlowService } from 'app/bookings/services/booking-flow.service';

@Component({
	selector: 'amd-generic-view-attachments',
	templateUrl: './generic-view-attachments.component.html',
	styleUrls: ['./generic-view-attachments.component.scss']
})
export class GenericViewAttachmentsComponent implements OnInit, OnChanges {
	@ContentChild('attachmentGlobalActions') attachmentGlobalActions: TemplateRef<any>;
	@ContentChild('addFile') addFile: TemplateRef<any>;
	@Input() translateContext: TranslateContext;
	@Input() attachmentsBlockList: AttachmentsBlocksList;
	@Input() canAddFile: boolean;
	@Input() canEdit: boolean;
	@Input() canDelete?: boolean;
	@Input() zipFileName: string = 'ZIP';
	@Input() actionOnZipClick: (files: GenericAttachedFile[]) => void;
	@Input() actionOnDownloadFilesClick: (files: GenericAttachedFile[]) => void;
	@Input() working: WorkingModel;
	@Input() dossier: DossierModel;
	@Input() isReadonly?: boolean;
	@Input() lazyLoading?: boolean;
	@Output() uploadFileEventEmitter: EventEmitter<void> = new EventEmitter<void>();

	item: FormItemsModel;
	isRead: boolean;
	isReply: boolean;
	isSend: boolean;
	workingTypes: typeof WorkingTypes = WorkingTypes;
	canViewPdf: boolean=false;
	permissionMail: boolean = false;
	sharedTranslateContext: TranslateContext = TranslateContext.SHARED;
	isReadonlyProfile: boolean = false;
	isShortTerms: boolean = false; 
	isAttachmentListVisible: boolean = true; 
	isClaimsAuthorityProfile: boolean = false;
	constructor(
		public snackBar: MatSnackBar,
		public bookingFlowService: BookingFlowService,
		public uploadFileService: UploadFileService,
		private translatePipe: TranslatePipe,
		private permissionService: PermissionService,
	) {
		if(bookingFlowService.isRelief() || bookingFlowService.isPrelease()){
			this.isShortTerms = true;
		}
	}
	ngOnInit(): void {
		
		this.isReadonlyProfile = this.isReadonly || this.permissionService.getCurrentUserPermissions().hasProfile([PROFILES_CLAIMS_DEKRA_READONLY_KEY, ...PROFILE_CLAIMS_READONLY_LIST]);
		this.isClaimsAuthorityProfile = this.permissionService.getCurrentUserPermissions().hasProfile([PROFILES_CLAIMS_AUTHORITY_KEY]);
	}
	
	ngOnChanges(changes: SimpleChanges): void {
		if (!U.isEmpty(changes.lazyLoading) && !U.isEmpty(changes.lazyLoading.currentValue)) {
			this.isAttachmentListVisible = !changes.lazyLoading.currentValue;
			// this.isAttachmentListVisible = [true, undefined].includes(changes.lazyLoading.currentValue) ? true : false;
		}
	}	

	selectAllFiles(checkboxChange: MatCheckboxChange, list: AttachmentsBlock): void {
		list.items.filter(item => item.canCheck).filter(i => i.checked = checkboxChange.checked);
	}

	 showPdf(val: boolean) {
	 	this.canViewPdf=val;
	 }

	getPermissionMailPdf(listItems :GenericAttachedFile):boolean{
		if(listItems){
			if(listItems.blob_type == "pdf_email" ){
				this.permissionMail= this.getPermissionMail();
				this.showPdf(this.permissionMail);
				return this.permissionMail;
			}else{
				this.showPdf(true);
				return true  ;
			}
		}
		else {
			return false
		}
	}

	getPermissionMail():boolean{
		return this.permissionMail= this.permissionService.getCurrentUserPermissions().hasProfile([
				BookingsProfileKey.module_prelease_bookings_team,
				BookingsProfileKey.module_prelease_assistance_center,
				BookingsProfileKey.module_prelease_customer_service,
				BookingsProfileKey.module_prelease_customer_service_supervisor,
				BookingsProfileKey.module_prelease_sales,
				BookingsProfileKey.module_prelease_bookings_team_supervisor, 
				BookingsProfileKey.module_prelease_customer_finance]
		);
	}


	getAllFilesChecked(): GenericAttachedFile[] {
		return this.attachmentsBlockList.attachmentsBlocks.map(list => list.items.filter(item => item.checked))
			.reduce((previousValue, currentValue) => [...previousValue, ...currentValue]);
	}

	downloadFiles(files: GenericAttachedFile[]): void {
		if (this.actionOnDownloadFilesClick) {
			this.actionOnDownloadFilesClick(files);
			return;
		}
		files.filter((value, index) => {
			this.uploadFileService.downloadAttachedFile(value.file_manager_id).subscribe(
				response => {
					if (!U.isVoid(response)) {
						U.downloadFile(response, value.file_manager_name);
					} else {
						const config: MatSnackBarConfig = new MatSnackBarConfig();
						config.duration = 2000;
						config.panelClass = ['snack-bar-error'];
						this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
					}
					if (index === files.length - 1) {
						const config: MatSnackBarConfig = new MatSnackBarConfig();
						config.duration = 2000;
						config.panelClass = ['snack-bar-success'];
						this.snackBar.open(this.translatePipe.transform('TUTTI_GLI_ALLEGATI_SONO_STATI_SCARICATI', TranslateContext.SHARED), '', config);
					}
				}, () => {
					const config: MatSnackBarConfig = new MatSnackBarConfig();
					config.duration = 2000;
					config.panelClass = ['snack-bar-error'];
					this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
				});
		});
	}

	downloadZip(files: GenericAttachedFile[]): void {
		if (this.actionOnZipClick) {
			this.actionOnZipClick(files);
			return;
		}
		this.uploadFileService.downloadAttachedZip(files.map(item => item.file_manager_id)).subscribe(
			response => {
				if (!U.isVoid(response)) {
					U.downloadFile(response, this.zipFileName);
				} else {
					const config: MatSnackBarConfig = new MatSnackBarConfig();
					config.duration = 2000;
					config.panelClass = ['snack-bar-error'];
					this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
				}
			}, () => {
				const config: MatSnackBarConfig = new MatSnackBarConfig();
				config.duration = 2000;
				config.panelClass = ['snack-bar-error'];
				this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
			});
	}

	uploadFilesListener(): void {
		this.uploadFileEventEmitter.emit();
	}

	isChecked(list: AttachmentsBlock): boolean {
		return list.items.filter(item => item.checked).length === list.items.filter(item => item.canCheck).length;
	}

	loadAttachments(): void {
		this.isAttachmentListVisible = true;
	}	
}